

export const useMapStyle = (mode: string) => {

  const client = process.env.REACT_APP_CLIENT || 'core';

  if (client === 'gravity') {
    if (mode === 'dark') {
      return "mapbox://styles/mpilarczykstarcount/clzl1q9lh002u01pd8s03dapo";
    } else {
      return "mapbox://styles/mpilarczykstarcount/cm0tlbxd100p801qudsi79pj0";
    }
  } else {
    if (mode === 'dark') {
      return "mapbox://styles/mpilarczykstarcount/clkgquj99007501qpdl0ebfr5";
    } else {
      return "mapbox://styles/mpilarczykstarcount/clzjoxepg004a01qx6ytt26kd";
    }
  }
}

export const useMapHeight = () => {
  const client = process.env.REACT_APP_CLIENT || 'core';

  if (client === 'gravity') {
    return 440
  } else {
    return 350
  }
}
